import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import './VisionSection.css';

const VisionSection = () => {
  return (
    <section className="vision-section">
      <div className="vision-background">
        <img 
          src="https://images.unsplash.com/photo-1530549387789-4c1017266635?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
          alt="Équipe sportive unie et déterminée"
          className="vision-image"
        />
        <div className="vision-overlay"></div>
      </div>
      
      <Container maxWidth="lg" className="vision-container">
        <Box className="vision-content">
          <Typography variant="h2" className="vision-title">
            Notre Vision
          </Typography>
          <Typography variant="h3" className="vision-subtitle">
            Devenir la plateforme de référence du sport français
          </Typography>
          <div className="vision-text">
            <Typography variant="body1" className="vision-paragraph">
              Nous rêvons d'un écosystème sportif où chaque talent trouve sa place, 
              où chaque organisation accède facilement aux compétences dont elle a besoin, 
              et où la passion du sport unit tous les acteurs.
            </Typography>
            <Typography variant="body1" className="vision-paragraph">
              Notre ambition est de démocratiser l'accès aux services sportifs de qualité, 
              de professionnaliser davantage le secteur, et de contribuer au développement 
              du sport à tous les niveaux : du club amateur aux fédérations nationales.
            </Typography>
            <Typography variant="body1" className="vision-paragraph">
              Ensemble, nous construisons l'avenir du sport français, 
              un projet à la fois, une mission à la fois.
            </Typography>
          </div>
          
          <Box className="vision-stats">
            <div className="stat-item">
              <Typography variant="h4" className="stat-number">
                1000+
              </Typography>
              <Typography variant="body2" className="stat-label">
                Professionnels inscrits
              </Typography>
            </div>
            <div className="stat-item">
              <Typography variant="h4" className="stat-number">
                500+
              </Typography>
              <Typography variant="body2" className="stat-label">
                Organisations partenaires
              </Typography>
            </div>
            <div className="stat-item">
              <Typography variant="h4" className="stat-number">
                2000+
              </Typography>
              <Typography variant="body2" className="stat-label">
                Missions réalisées
              </Typography>
            </div>
          </Box>
        </Box>
      </Container>
    </section>
  );
};

export default VisionSection;